<template>
  <div class="modify-info">
    <div class="header">
      <div class="title">编辑成员信息与权限</div>
    </div>
    <div class="info-con" v-loading="pageLoading">
      <!-- <p class="tips">创建成员后 , 使用此账号可以登录好生意用户管理后台，不可登录好生意商户端，你可以为不同的登录账号设置不同的权限范围</p> -->
      <div class="form">
        <el-form :model="newUserForm" :rules="newUserRules" inline class="inline-form" ref="newUserForm" label-width="100px">
          <div class="formBox">
            <div class="left itemSame">
              <el-form-item label="姓名" prop="operatorName">
                <el-input size="small" v-model="newUserForm.operatorName" autocomplete="off" placeholder="请输入成员姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input size="small" v-model.number="newUserForm.mobile" placeholder="请输入成员手机号" clearable></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input type="password" size="small" v-model="newUserForm.password" autocomplete="off" placeholder="请输入8~16位数字加字母组合" clearable></el-input>
              </el-form-item>
              <el-form-item label="门店选择" class="storeList" v-if="groupType==0">
                <custom-select size="small" v-model="merchantIdList" :list="shopList"></custom-select>
              </el-form-item>
              <el-form-item label="权限菜单" v-if="groupType==0">
                <el-checkbox-group v-model="authorityIdList">
                  <el-checkbox v-for="(item,index) in permissonList" :label="item.id" :key="index">{{ item.authorityName }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div class="right itemSame">
              <el-form-item label="账号" prop="loginUserName" v-if="isNewUser">
                <el-input size="small" v-model="newUserForm.loginUserName" autocomplete="off" clearable placeholder="请输入成员账号"></el-input>
              </el-form-item>
              <el-form-item label="账号" prop="loginUserName" v-else>
                <div>{{newUserForm.loginUserName}}</div>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" size="small" v-model="newUserForm.remark" placeholder="请输入成员备注信息"></el-input>
              </el-form-item>
            </div>
            <div v-if="groupType!=0" class="otherShop">
              <div class="storeCon">
                <div class="store">
                  <div class="title">门店选择</div>
                  <div class="desc">必须选择大于1个以上的门店，选择门店后此账号可见该门店的相关数据</div>
                  <el-checkbox v-model="isAllCheckedShop">全选</el-checkbox>
                  <el-tree :data="shopListTree" show-checkbox node-key="merchantId" check-strictly ref="tree" :default-expanded-keys="defaultChckedKeys" :default-checked-keys="defaultChckedKeys" :props="defaultProps"></el-tree>
                </div>
              </div>
              <div class="auth">
                <div class="item firstItem">
                  <div class="title">PC后台权限账单</div>
                  <el-checkbox-group v-model="authorityIdList">
                    <el-checkbox v-for="(item,index) in permissonList" :label="item.id" :key="index">{{ item.authorityName }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="item">
                  <div class="title">商户端权限菜单</div>
                  <el-checkbox-group v-model="merchantAuthorId">
                    <el-checkbox v-for="(item,index) in merchantPermission" :label="item.id" :key="index">{{ item.authorityName }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>

          <el-form-item class="btnSubmit">
            <el-button @click="cancelNewUser">取消</el-button>
            <el-button type="primary" @click="submitNewAcconunt('newUserForm')" :loading="newUserLoading">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { checkPhone, checkPass } from "@/utils/validate";
import CustomSelect from "@/components/CustomSelect/index.vue";
import { queryShopList } from "@/api/merchant-info";
import { listBackstageUserAuthority, saveBackstageUserInfo } from "@/api/member-permisson";

export default {
  components: { CustomSelect },
  data() {
    return {
      newUserRules: {
        operatorName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '姓名不支持特殊字符和空格', trigger: 'blur',
          },
        ],
        loginUserName: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '账号不支持特殊字符和空格', trigger: 'blur',
          },
        ],
        password: [{ validator: checkPass, trigger: "blur", required: true }],
        mobile: [{ validator: checkPhone, trigger: "blur", required: true }],
        remark: [
          {
            min: 0, max: 15, message: "长度在 0 到 15 个字符", trigger: "blur",
          },
        ],
      },
      shopList: [],
      shopListTree: [],
      newUserForm: {
        loginUserName: "",
        operatorName: "",
        remark: "",
        password: "",
        mobile: "",
        id: "",
      },
      defaultProps: {
        children: 'children',
        label: 'merchantName',
      },
      defaultChckedKeys: ['3010011860'],
      isAllCheckedShop: false,
      merchantIdList: [],
      authorityIdList: [],
      merchantAuthorId: [],
      merchantPermission: [],
      newUserLoading: false,
      pageLoading: false,
      permissonList: [],
      isNewUser: true,
      shopType: 1,
      groupType: 0,
      authorId: [],
    };
  },
  watch: {
    isAllCheckedShop(val) {
      if (val) {
        // 获取权限的merchantName
        const merchantIdArr = this.shopList.map(v => v.merchantId);
        this.$refs.tree.setCheckedKeys(merchantIdArr);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
  },
  methods: {
    // 赋初始值
    setBaseInfo() {
      const baseInfo = JSON.parse(localStorage.getItem("memeberInfo"));
      // 是否是新建
      this.isNewUser = localStorage.getItem("memeberInfo") === "{}";
      this.newUserForm.loginUserName = baseInfo.userName;
      this.newUserForm.operatorName = baseInfo.operatorName;
      this.newUserForm.remark = baseInfo.remark;
      this.newUserForm.mobile = baseInfo.mobile;
      this.newUserForm.id = baseInfo.id;
      this.newUserForm.password = localStorage.getItem("memeberInfo") === "{}" ? '' : "LLLLLLL999";
      if (this.groupType === 1) {
        this.defaultChckedKeys = baseInfo.merchantList ? baseInfo.merchantList.map(e => e.merchantId) : [];
      } else if (this.isNewUser) {
        // 非集团商户新增时，门店默认不选中
        this.merchantIdList = baseInfo.merchantList ? baseInfo.merchantList.map(e => e.merchantId) : [this.shopList[0].merchantId];
      }
      if (baseInfo.authorityList) {
        baseInfo.authorityList.forEach((e) => {
          if (e.type === 0) {
            this.authorId.push(e.id);
          }
        });
      } else {
        this.authorId = [];
      }

      if (baseInfo.authorityList) {
        baseInfo.authorityList.forEach((e) => {
          if (e.type === 1) {
            this.merchantAuthorId.push(e.id);
          }
        });
      } else {
        this.merchantAuthorId = [];
      }
    },
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "", merchantName: "", merchantId: "", pageNo: 1, pageSize: 1000,
      };
      queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          this.shopList = res.data.data.list;
          if (this.groupType === 0) {
            res.data.data.list.unshift({ merchantId: "@", merchantName: "全部门店", checked: true });
            this.merchantIdList = [this.shopList[0].merchantId];
          } else {
            let middleTree = [...res.data.data.list];
            // 获取根节点的groupHeadMerchantId
            middleTree = middleTree.sort((a, b) => a.groupType - b.groupType);
            const t = this.filterArray(middleTree, middleTree[0].groupHeadMerchantId);
            this.shopListTree = t;
          }
          this.setBaseInfo();
          this.getPermissonList();
        }
      });
    },
    filterArray(data, parent) {
      const vm = this;
      const tree = [];
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].groupHeadMerchantId === parent) {
          const obj = data[i];
          temp = vm.filterArray(data, data[i].merchantId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    cancelNewUser() {
      this.$router.go(-1);
    },
    submitNewAcconunt(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            id: this.newUserForm.id,
            loginUserName: this.newUserForm.loginUserName,
            operatorName: this.newUserForm.operatorName,
            remark: this.newUserForm.remark,
            mobile: this.newUserForm.mobile,
          };
          if (this.newUserForm.password !== "LLLLLLL999") {
            params.password = this.$md5(this.newUserForm.password);
          } else {
            params.password = this.newUserForm.password;
          }
          const authList = this.authorityIdList.concat(this.merchantAuthorId);
          params.authorityIdList = authList;
          if (this.groupType === 1) {
            params.merchantIdList = [...this.$refs.tree.getCheckedKeys(), ...this.$refs.tree.getHalfCheckedKeys()];
          } else {
            params.merchantIdList = this.shopType ? this.merchantIdList : [this.merchantId];
          }

          // 如果是全部门店，需要遍历获取所有的门店id
          if (this.merchantIdList[0] === "@") {
            params.merchantIdList = [];
            this.shopList.forEach((v) => {
              if (v.merchantId !== "@") {
                params.merchantIdList.push(v.merchantId);
              }
            });
          }
          // 必须选择一个以上的门店和权限
          if (this.shopType && params.merchantIdList.length === 0) {
            this.$message({
              showClose: true,
              message: "请选择至少1个以上的门店",
              type: "error",
            });
          } else if (params.authorityIdList.length === 0) {
            this.$message({
              showClose: true,
              message: "请选择至少1个以上的权限",
              type: "error",
            });
          } else {
            this.newUserLoading = true;
            saveBackstageUserInfo(params).then((res) => {
              this.newUserLoading = false;
              if (res.data.error_code === 0) {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/member-permisson/detail");
              }
            });
          }
        }
      });
    },
    // 获取权限列表
    getPermissonList() {
      this.pageLoading = true;
      listBackstageUserAuthority().then((res) => {
        this.pageLoading = false;
        if (res.data.error_code === 0) {
          res.data.data.forEach((e) => {
            if (e.type === 0) {
              this.permissonList.push({
                id: e.id,
                authorityName: e.authorityName,
              });
            } else if (e.type === 1) {
              this.merchantPermission.push({
                id: e.id,
                authorityName: e.authorityName,
              });
            }
          });
          this.authorityIdList = this.authorId;
          this.merchantAuthorId = this.merchantAuthorId;
        }
      });
    },
  },
  created() {
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      this.shopType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).shopType;
      this.merchantId = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantId;
      this.groupType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).groupType;
    }
  },
};
</script>
<style lang="scss">
.modify-info {
  > .header {
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
  }
  .info-con {
    padding: 40px 0px;
    .form {
      // margin-top: 40px;
      .el-form {
        .formBox {
          display: flex;
          flex-wrap: wrap;
          // padding: 0 50px;
        }
        .el-form-item {
          margin-bottom: 30px;
        }
      }
    }
    .itemSame {
      width: 40%;
    }
    .left {
      padding-left: 50px;
    }
    .right {
      padding-right: 50px;
    }
    .tips {
      color: #999;
      font-size: 14px;
      padding: 0 50px;
    }
    .el-form-item__content {
      width: 350px;
      .el-textarea__inner {
        min-height: 135px !important;
      }
    }
    .el-form-item__label {
      text-align: left;
    }
    .btnSubmit {
      padding: 30px 50px 0;
      .el-button {
        width: 90px;
        height: 32px;
        line-height: 0px;
      }
    }
  }
  .yk-custom-select-container {
    .el-select {
      .el-select__tags {
        min-width: 365px !important;
        max-width: 365px !important;
        margin-top: 4px;
      }
    }
  }
  .storeCon {
    padding: 20px 0px;
    background: #f7f7f7;
    .store {
      background: #fff;
      padding: 40px 50px;
      .title {
        font-size: 14px;
        color: #333333;
      }
      .desc {
        font-size: 12px;
        color: #cccccc;
        margin: 12px 0 35px 0;
      }
    }
    .el-tree {
      > .el-tree-node {
        padding: 10px 0;
      }
      > .is-focusable {
        border-bottom: 1px solid #eeeeee;
      }
      .is-focusable:last-child {
        border-bottom: none;
      }
    }
    .el-tree-node {
      margin-top: 10px;
    }
    .el-tree-node__content:hover {
      background-color: #ffffff;
    }
    .is-current {
      .el-tree-node__content {
        background-color: #ffffff;
      }
    }
    .el-tree-node:last-child {
      padding-bottom: 0px;
    }

    .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }
    .el-checkbox__inner::after {
      top: 2px;
      left: 5px;
    }
    .el-tree-node__expand-icon {
      font-size: 17px;
      padding-right: 10px;
      &.el-tree-node__expand-icon {
        color: #595959;
      }
      &.is-leaf {
        color: transparent;
      }
    }
  }
  .auth {
    padding: 10px 50px 10px;
    .title {
      color: #333;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .item {
      padding: 30px 0;
    }
    .firstItem {
      border-bottom: 1px solid #eeeeee;
    }
  }
  .otherShop {
    width: 100%;
  }
}
</style>
